var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('AddMember',{staticClass:"col-10 col-md-8"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }